// extracted by mini-css-extract-plugin
export default {"create-breakout-modal-prompt":"CreateBreakout_create-breakout-modal-prompt__WzcaC"};